<template>
  <div class="case-flow-list-container">
    <!-- 办案列表表格 -->
    <div class="table-box">
      <el-card class="box-card">
        <el-table
          :data="handlingList"
          stripe
          v-loading="loading"
          style="width: 100%"
          :header-cell-style="{background: '#f5f7fa', color: '#606266'}">
          <el-table-column prop="case_info.house.ancestor_name" label="房产" min-width="250"></el-table-column>
          <el-table-column prop="flow_type" label="执行类型" width="150">
            <template slot-scope="scope">
              {{ scope.row.flow_type | getFlowType }}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="180">
          </el-table-column>
          <el-table-column prop="executionContent" label="执行内容" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.flow_data | flowData }}
            </template>
          </el-table-column>
          <el-table-column label="上传资料" min-width="200">
            <template slot-scope="scope">
              <el-link
                v-for="(file, index) in scope.row.file_list"
                :key="index"
                @click="fileDownload(file.file_url)"
                style="display: block;">
                {{ file.file_name }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-link
                @click="viewCase(scope.row)" style="margin-right:12px;"
                type="primary">
                查看案件
              </el-link>
              <el-link @click="showFileDetail(scope.row)" type="primary">案件资料</el-link>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-wrapper" v-if="total > 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 案件详情弹窗 -->
    <case-detail :visible="detail.visible" :case-id="detail.case_id" @close="onCloseDetail" />

    <!-- 文件详情弹窗 -->
    <el-dialog
      title="案件资料完善"
      :visible.sync="fileDetailDialog.visible"
      width="80%"
      @close="onCloseFileDetail">
      <CaseFileForm v-if="fileDetailDialog.visible" :caseItem="fileDetailDialog.caseItem" />
    </el-dialog>
  </div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";
import caseJs from './case.js'
import CaseDetail from './case_detail.vue';
import CaseFileForm from "./case_file_form.vue"; // 导入案件详情组件

export default {
  name: 'CaseFlowList',
  components: {
    CaseFileForm,
    CaseDetail // 注册案件详情组件
  },
  data() {
    return {
      loading: false,
      handlingList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      batch_no: this.getBatchNoFromUrl(), // 从URL获取batch_no
      flowTypes: {}, // 存储流程类型
      detail: {
        visible: false,
        case_id: 0
      },
      fileDetailDialog : {
        visible : false ,
        caseItem : null,
      }
    }
  },
  created() {
    console.log('URL:', window.location.href); // 调试输出URL
    console.log('Batch No:', this.batch_no); // 调试输出获取到的批次号
    // 初始化流程类型
    this.flowTypes = caseJs.flowType();
    // 加载列表数据
    this.getHandlingList();
  },
  methods: {
    // 从URL获取batch_no
    getBatchNoFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);

      // 尝试不同的可能参数名
      const possibleParamNames = ['batch_no', 'batch_no[]', 'batchNo', 'batch', 'no'];
      for (const paramName of possibleParamNames) {
        const paramValue = urlParams.get(paramName);
        if (paramValue) {
          console.log(`Found ${paramName}: ${paramValue}`);
          return paramValue;
        }
      }

      // 如果查询参数中没有，尝试从hash中获取
      const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
      for (const paramName of possibleParamNames) {
        const paramValue = hashParams.get(paramName);
        if (paramValue) {
          console.log(`Found ${paramName} in hash: ${paramValue}`);
          return paramValue;
        }
      }

      console.log('No batch_no found in URL');
      return '';
    },

    // 获取办案列表
    async getHandlingList() {
      this.loading = true;
      try {
        // 示例数据 - 在实际使用时替换为真实的API调用
        ButlerHttp.get('LawCase/getFlowList', {
          page: this.currentPage,
          limit: this.pageSize,
          batch_no: this.batch_no // 使用从URL获取的batch_no
        }, res => {
          if(res.code) {
            this.handlingList = res.data.list || [];
            this.total = res.data.total || 0;
          } else {
            this.$message.error(res.msg || '获取列表失败');
            this.handlingList = [];
            this.total = 0;
          }
          this.loading = false;
        });
      } catch (error) {
        console.error('获取办案列表失败:', error);
        this.$message.error('获取办案列表失败');
        this.loading = false;
        this.handlingList = [];
        this.total = 0;
      }
    },

    // 文件下载
    fileDownload(url) {
      let open_url = caseJs.getFileUrl(url);
      window.open(open_url);
    },

    // 查看案件详情
    viewCase(row) {
      // 从row中获取案件ID并打开案件详情弹窗
      this.detail.case_id = row.case_id || row.id; // 尝试获取案件ID
      this.detail.visible = true;
    },

    // 关闭案件详情弹窗
    onCloseDetail() {
      this.detail.visible = false;
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getHandlingList();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getHandlingList();
    },

    showFileDetail(row) {
      row.id = row.case_id ;
      this.fileDetailDialog.visible = true;
      this.fileDetailDialog.caseItem = row;
    },

    // 关闭文件详情弹窗并刷新列表
    onCloseFileDetail() {
      // 刷新列表数据
      this.getHandlingList();
    },

  },
  filters: {
    // 获取流程类型
    getFlowType(type) {
      let flow_type = caseJs.flowType();
      return flow_type[type] || type;
    },

    // 获取流程数据
    flowData(data) {
      return caseJs.flowData(data);
    }
  }
}
</script>

<style scoped>
.case-flow-list-container {
  padding: 20px;
  background-color: #f5f7fa;
}

.table-box {
  margin-bottom: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/law_case/case_flow_list.vue